import {MapStyleDark} from "./mapStyles.js";
import EventMarker from "./Markers/EventMarker";
import MapEventSidebar from "./MapEventSidebar";
import RouteMarker from "./Markers/RouteMarker";
import PhotoMarker from "./Markers/PhotoMarker";
import RouteChart from "./RouteChart";

import { Fancybox } from '@fancyapps/ui';
import {metersToDistance, secondsToHoursMin, secondsToTime} from "../Helpers";
import BusinessMarker from "./Markers/BusinessMarker";
import TwistyRouteMarker from "./Markers/TwistyRouteMarker";
import PoiMarker from "./Markers/PoiMarker";

class MapViewer{

    constructor(opts){

        this.mapElementId = 'map';
        this.mapElement = null;
        this.zoomControl = false;
        this.map = null;
        this.coordinates = {lat: 42, lng: -31};
        this.defaultZoom = 4;

        this.freeMode = 'routes';

        this.sidebar = null;
        this.showMenu = false;
        this.showSearchLocation = false;
        this.showRoutesList = false;
        this.showEventsList = false;
        this.showPoiList = false;
        this.updatePointsAtChangeMap = true;

        this.strokeColor = '#1aa7ec';
        this.strokeWeight = 4;
        this.strokeOpacity = 0.2;

        this.eventsListContainer = null;
        this.routesListContainer = null;

        if(opts){
            this.mapElementId  = opts.mapElementId || 'map';
            this.zoomControl  = opts.zoomControl !== undefined ? opts.zoomControl : true;
            this.coordinates  = opts.coordinates || {lat: 42, lng: -31};

            if(opts.coordinates){
                this.defaultZoom = 6;
            }

            this.freeMode = opts.freeMode ?? 'routes';
            this.showMenu = opts.showMenu ?? true;
            this.showSearchLocation = opts.showSearchLocation ?? true;
            this.showRoutesList = opts.showRoutesList ?? true;
            this.showEventsList = opts.showEventsList ?? true;
            this.updatePointsAtChangeMap = opts.updatePointsAtChangeMap ?? this.updatePointsAtChangeMap;
        }

        this.mapContainer = $(
            '<div class="mapContainer">' +
                '<div id="map"></div>' +
            '</div>'
        );

        this.mapElement = this.mapContainer.find('#' + this.mapElementId)[0];

        this.route = null;
        this.render_polylines   = [];
        this.render_routes      = [];
        this.markers            = [];
        this.chartMarkerPosition = null;

        this.rendered_short_paths = [];

        this.renderedObjects = {
            events: new Map,
            routes: new Map,
            business: new Map,
            poi: new Map,
            twistyPoints: new Map
        };

        // Если активно - все лишние элементы спрятаны. т.е. сейчас что-то открыто подробно на карте
        this.hidenMapObjects = false;
        this.savedMapPosition = null;

    }

    initMap(){

        this.map = new google.maps.Map(this.mapElement, {
            center: this.coordinates,
            zoom: this.defaultZoom,
            maxZoom: 20,
            minZoom: 4,
            styles: MapStyleDark,
            zoomControl: this.zoomControl,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_BOTTOM,
            },
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            draggableCursor: 'default',
            gestureHandling: 'greedy'
        })

        // Добавляем основной слой карты
        this.map.setMapTypeId('roadmap');

        //this.initWeatherLayer();
        //this.initTwistyLayer();

        this._initActions();

        if(this.showMenu){
            this.renderMapMenu();
        }

        if(this.showSearchLocation){
            this.renderSearchLocation();
        }

    }

    initTwistyLayer(){
        this.twistyLayer = new google.maps.Data();
        this.twistyLayer.setMap(this.map);
        // Установка стиля для линий
        this.twistyLayer.setStyle({
            strokeOpacity: 0.8,
            strokeColor: '#f89500',
            strokeWeight: this.strokeWeight
        });
    }

    initWeatherLayer(){
        // Получаем данные о погоде
        let weatherApiKey = 'd191a3ba1fa6d0c18da2b2f2a9c7481a';

        // Создаем слой погоды
        let weatherLayer = new google.maps.ImageMapType({
            getTileUrl: function (coord, zoom) {
                return 'https://tile.openweathermap.org/map/precipitation_new/' + zoom + '/' + coord.x + '/' + coord.y + '.png?appid=' + weatherApiKey;
            },
            tileSize: new google.maps.Size(256, 256),
            name: 'Weather Layer',
            maxZoom: 18
        });

        // Добавляем слой погоды поверх основного слоя
        this.map.overlayMapTypes.insertAt(0, weatherLayer);
    }

    clearTwistyLayer() {
        if (this.twistyLayer) {
            this.twistyLayer.forEach(feature => {
                this.twistyLayer.remove(feature);
            });
        }
    }


    showTwistyPath(path){

        let self = this;

        let polylineCoordinates = path.map(function(point){
            return new google.maps.LatLng(point[0], point[1]);
        });

        this.twistyLayer.add({
            geometry: new google.maps.Data.LineString(polylineCoordinates)
        });

    }

    _initActions(){

        let self = this;

        self.directionsService = new google.maps.DirectionsService();

        if(self.updatePointsAtChangeMap){

            self.map.addListener('dragend', () => {
                self.updatePoints();
            });
            self.map.addListener('zoom_changed', () => {
                self.updatePoints();
            });
            self.map.addListener('projection_changed', () => {
                self.updatePoints();
            });

        }

    }

    /**
     * routes | events
     * @param mode
     */
    setFreeMode(mode){

        let self = this;

        if(this.freeMode === mode) return true;
        this.freeMode = mode;

        switch(this.freeMode){
            case "routes":
                self.deleteAllRenderedEvents()
                self.deleteAllRenderedPoi()
                self.updatePoints();
                break;
            case "events":
                self.deleteAllRenderedShortRoutes()
                self.deleteAllRenderedPoi()
                self.updatePoints();
                break;
            case "poi":
                self.deleteAllRenderedShortRoutes()
                self.deleteAllRenderedEvents()
                self.updatePoints();
                break;
        }

    }

    mouseover(routeId){
        let self = this;
        let r = self.renderedObjects.routes.get(routeId);
        r.polylines.forEach(pl => {
            pl.setOptions({
                strokeColor:'#ff4800',
                strokeOpacity: 1.0
            });
        })
    };

    mouseout(routeId) {
        let self = this;
        let r = self.renderedObjects.routes.get(routeId);
        r.polylines.forEach(pl => {
            pl.setOptions({
                strokeColor: self.strokeColor,
                strokeOpacity: self.strokeOpacity,
            });
        })
    }

    renderSearchLocation(){

        let self = this;

        let locationContainer = $('<div class="map_menu_with_location">' +
            '<div class="search_location" style="display: block">' +
                '<i class="icon-location-pin2"></i>' +
                '<input type="text" class="location autocomplete" data-search="true" autocomplete="off" placeholder="Search address">' +
            '</div>' +
            '<div class="menu">' +
                '<button type="button" class="mapMenuItem routes active"><i class="icon-map_routes"></i> Routes</button>' +
                '<button type="button" class="mapMenuItem events"><i class="icon-map_events"></i> Events</button>' +
                '<button type="button" class="mapMenuItem poi"><i class="icon-map_poi"></i> Poi</button>' +
            '</div>' +
        '');


        let menuItems = locationContainer.find('.menu');
        let routes = menuItems.find('.routes');
        let events = menuItems.find('.events');
        let poi = menuItems.find('.poi');

        routes.on('click', function(){
            self.setFreeMode('routes');
            $(this).parent().find('.mapMenuItem').removeClass('active');
            $(this).addClass('active');
        })
        events.on('click', function(){
            self.setFreeMode('events');
            $(this).parent().find('.mapMenuItem').removeClass('active');
            $(this).addClass('active');
        })
        poi.on('click', function(){
            self.setFreeMode('poi');
            $(this).parent().find('.mapMenuItem').removeClass('active');
            $(this).addClass('active');
        })

        self.mapContainer.append(locationContainer);

        locationContainer.on('focus', '.location.autocomplete', function(){

            $(this).autocomplete({
                limit: 10,
                delay: 300,
                minLength: 2,
                source: function(request, response){
                    $.ajax({
                        url: "https://maps.googleapis.com/maps/api/geocode/json",
                        dataType:"json",
                        data:{address: request.term, sensor: "false", language: "en", key: "AIzaSyB0y-D7-Wh6t1lyNoBvlHJqLq1smR6Bk8I"},
                        success: function(data){
                            if(data.status === "OK"){
                                response($.map(data.results, function(item){
                                    return{
                                        label: item.formatted_address,
                                        value: item.formatted_address,
                                        location: item.geometry.location
                                    }
                                }));
                            }
                        }
                    });
                },
                select: function(event, ui){
                    if(ui.item){

                        self.map.setCenter(new google.maps.LatLng(ui.item.location.lat, ui.item.location.lng));
                        self.map.setZoom(11);

                        if(self.autoSetMarkerAfterSearch === true){
                            self.placeMarker(new google.maps.LatLng(ui.item.location.lat, ui.item.location.lng));
                        }

                    }
                }
            })
        })



    }

    showMapPoints(points){

        let self = this;

        if(points.business){

            if(self.renderedObjects.business.size > 0){
                self.renderedObjects.business.forEach((marker, id) => {
                    if(!points.business.find(item => item.id === id)){
                        self.deleteMapObject('business', id);
                    }
                });
            }

            points.business.forEach(business => {

                if(!self.renderedObjects.business.has(business.id)){

                    let iconsUrls = new Map;

                    business.services.forEach(service => {
                        iconsUrls.set(service.category.id, service.category.icon);
                    })

                    let marker = (
                        new BusinessMarker(
                            new google.maps.LatLng(business.location.coordinates.lat, business.location.coordinates.lng),
                            iconsUrls
                        )
                    );
                    self.renderedObjects.business.set(business.id, marker);

                    marker.setMap(self.map);
                    marker.addListener('click', function(e){
                        e.stopPropagation();
                        window.location.href = business.url;
                    })

                }

            })

        }

        if(points.poi){

            if(self.renderedObjects.poi.size > 0){
                self.renderedObjects.poi.forEach((marker, id) => {
                    if(!points.poi.find(item => item.id === id)){
                        self.deleteMapObject('poi', id);
                    }
                });
            }

            points.poi.forEach(poi => {

                if(!self.renderedObjects.poi.has(poi.id)){

                    let marker = (new PoiMarker).createMarker(poi);
                    self.renderedObjects.poi.set(poi.id, marker);

                    marker.setMap(self.map);
                    marker.addListener('click', function(){
                        self.openPoi(poi.id);
                    })

                }

            })

        }

        if(points.twistyRoutes){

            self.clearTwistyLayer();
            if(points.twistyRoutes.length > 0){

                if(points.twistyRoutes[0].route_path.length > 0){

                    self.deleteMapObject('twistyPoints', 'all');

                    points.twistyRoutes.forEach(road => {
                        self.showTwistyPath(road.route_path[0]);
                    })

                }else{

                    let twistyIds = new Set;
                    points.twistyRoutes.forEach(road => {
                        twistyIds.add(road.id);
                    })

                    if(self.renderedObjects.twistyPoints.size > 0){
                        self.renderedObjects.twistyPoints.forEach((marker, id) => {
                            if(!twistyIds.has(id)){
                                self.deleteMapObject('twistyPoints', id);
                            }
                        });
                    }

                    points.twistyRoutes.forEach(road => {
                        if(!self.renderedObjects.twistyPoints.has(road.id)){

                            let marker = (new TwistyRouteMarker).createMarker(road);
                            self.renderedObjects.twistyPoints.set(road.id, marker);

                            marker.setMap(self.map);
                            marker.addListener('click', function(){

                            })

                        }
                    })

                }

            }

        }

    }

    showRoutes(routes){

        let self = this;

        if(routes.length > 0){
            let routeIds = new Set;
            routes.forEach(route => {
                routeIds.add(route.id);
            })

            if(self.renderedObjects.routes.size > 0){
                self.renderedObjects.routes.forEach((obj, id) => {
                    if(!routeIds.has(id)){
                        self.deleteMapObject('routes', id);
                    }
                });
            }

            routes.forEach(route => {
                if(!self.renderedObjects.routes.has(route.id)){

                    let marker = (new RouteMarker).createMarker(route);
                    let obj = {marker: marker, polylines: []}

                    route.short_path.forEach(section => {
                        let polyline = self.showShortPath(section);

                        obj.polylines.push(polyline);

                        self.renderedObjects.routes.set(route.id, obj);

                        marker.setMap(self.map);
                        marker.addListener('click', function(){
                            self.openRoute(route.key);
                            self.mouseout(route.id);
                        })

                        polyline.setMap(self.map);
                        polyline.addListener('click', function(){
                            self.openRoute(route.key);
                        })

                        polyline.addListener('mouseover', function(){
                            self.mouseover(route.id)
                        });
                        polyline.addListener('mouseout', function(){
                            self.mouseout(route.id)
                        });
                        marker.addListener('mouseover', function(){
                            self.mouseover(route.id)
                        });
                        marker.addListener('mouseout', function(){
                            self.mouseout(route.id)
                        });

                    })

                }
            })
        }

        if(self.showRoutesList){
            self.renderRoutesList(routes);
        }


    }

    showEvents(events){

        let self = this;

        if(events.length > 0){

            let eventIds = new Set;
            events.forEach(ev => {
                eventIds.add(ev.id);
            })

            if(self.renderedObjects.events.size > 0){
                self.renderedObjects.events.forEach((marker, id) => {
                    if(!eventIds.has(id)){
                        self.deleteMapObject('events', id);
                    }
                });
            }

            events.forEach(ev => {
                if(!self.renderedObjects.events.has(ev.id)){

                    let marker = (new EventMarker).createMarker(ev);
                    self.renderedObjects.events.set(ev.id, marker);

                    marker.setMap(self.map);
                    marker.addListener('click', function(){
                        self.openEvent(ev.id);
                    })

                }
            })

        }

        if(self.showEventsList){
            self.renderEventsList(events);
        }


    }

    showPoi(poi){

        let self = this;

        if(poi.length > 0){

            let poiIds = new Set;
            poi.forEach(ev => {
                poiIds.add(ev.id);
            })

            if(self.renderedObjects.poi.size > 0){
                self.renderedObjects.poi.forEach((marker, id) => {
                    if(!poiIds.has(id)){
                        self.deleteMapObject('poi', id);
                    }
                });
            }

            poi.forEach(p => {
                if(!self.renderedObjects.poi.has(p.id)){

                    let marker = (new PoiMarker).createMarker(p);
                    self.renderedObjects.poi.set(p.id, marker);

                    marker.setMap(self.map);
                    marker.addListener('click', function(){
                        self.openPoi(p.id);
                    })

                }
            })

        }

    }

    updatePoints(){

        let self = this;

        if(self.hidenMapObjects === true) return false;

        if(self.updatePointsTimer){
            clearTimeout(self.updatePointsTimer);
        }

        if(self.getPointsInBounds){
            self.getPointsInBounds.abort();
        }

        self.updatePointsTimer = setTimeout(function(){

            let northeast = self.map.getBounds().getNorthEast().lat() + "," + self.map.getBounds().getNorthEast().lng();
            let southwest = self.map.getBounds().getSouthWest().lat() + "," + self.map.getBounds().getSouthWest().lng();


            //Рабочие точки POI
            self.getPointsInBounds = $.get('/ajax/map.getPointsInBounds', {
                northeast: northeast,
                southwest: southwest,
                types: ['business', /*'twistyRoutes', 'poi'*/]
            }, function(d){
                let res = ParseResp(d);
                self.showMapPoints(res.data.points);
            });


            if(self.freeMode === 'routes'){
                $.get('/ajax/routes.getInBounds', {
                    northeast: northeast,
                    southwest: southwest
                }, function(d){
                    let res = ParseResp(d);
                    self.showRoutes(res.data.items);
                });
            }

            if(self.freeMode === 'events'){
                self.clearTwistyLayer();
                $.get('/ajax/events.getInBounds', {
                    northeast: northeast,
                    southwest: southwest
                }, function(d){
                    let res = ParseResp(d);
                    self.showEvents(res.data.items);
                });
            }


            if(self.freeMode === 'poi'){
                self.clearTwistyLayer();
                $.get('/ajax/poi.getInBounds', {
                    northeast: northeast,
                    southwest: southwest
                }, function(d){
                    let res = ParseResp(d);
                    self.showPoi(res.data.items);
                });
            }

        }, 100);

    }

    renderMapMenu(){

        let self = this;

        let menuMobile = $('<div class="mapMenuMobile">' +
            '<div class="bottomMenu__left downloadAppDialog_btn">' +
                '<i class="icon-route_tracked"></i>' +
                '<span>Ride</span>' +
            '</div>' +
            '<div class="bottomMenu__right">' +
                '<span>Plan</span>' +
                '<i class="icon-track-02"></i>' +
            '</div>' +
            '<div class="buttonMenu"><i class="icon-map_routes"></i></div>' +
            '<div class="mapMenuMobile__items gap_2">' +
                '<div class="mapMenuMobile__item routes gap_2">' +
                    '<div class="mapMenuMobile__item-text">Routes</div>' +
                    '<div class="mapMenuMobile__item-btn"><i class="icon-map_routes"></i></div>' +
                '</div>' +
                '<div class="mapMenuMobile__item events gap_2">' +
                    '<div class="mapMenuMobile__item-text">Events</div>' +
                    '<div class="mapMenuMobile__item-btn"><i class="icon-map_events"></i></div>' +
                '</div>' +
            '</div>' +
        '</div>');

        let btnMenu = menuMobile.find('.buttonMenu');
        let menuItems = menuMobile.find('.mapMenuMobile__items');
        let routes = menuMobile.find('.routes');
        let events = menuMobile.find('.events');

        btnMenu.on('click', function(){
            menuItems.addClass('active');
        })
        $(document).on('click', function(event){
            if($(event.target).closest('.mapMenuMobile').length === 0){
                menuItems.removeClass('active');
            }
        })
        routes.on('click', function(){
            self.setFreeMode('routes');
            menuItems.removeClass('active');
            btnMenu.html(routes.find('.mapMenuMobile__item-btn i').clone());
        })
        events.on('click', function(){
            self.setFreeMode('events');
            menuItems.removeClass('active');
            btnMenu.html(events.find('.mapMenuMobile__item-btn i').clone());
        })

        self.getMapContainer().append(menuMobile);

    }

    removeRoutesList(){
        let self = this;
        if(self.routesListContainer){
            self.routesListContainer.remove();
            self.routesListContainer = null;
        }
    }

    renderRoutesList(routes){

        let self = this;

        self.removeRoutesList();

        self.routesListContainer = $('<div class="map_routesListContainer vertical"><div class="carousel custom-scrollbar"></div></div>');

        if(self.getMapContainer().width() < 1000){
            self.routesListContainer.removeClass('vertical');
            self.routesListContainer.find('.carousel').addClass('owl-carousel');
        }

        if(routes.length > 0){
            routes.forEach(route => {

                if(!route.image || !route.image.sizes){
                    return;
                }

                let image = route.image.sizes[1].url;

                const item = $(
                    '<div class="m_route-short">' +
                        '<div class="flex-col">' +
                            '<div class="flex-row">' +
                                '<div class="m_route-short_body">' +
                                    '<div class="image"><img src="' + image + '" alt></div>' +
                                '</div>' +
                                '<div class="m_route-short_head flex-row flex-around flex-center gap_1">' +
                                    '<div class="flex-col flex-center gap_1">' +
                                        '<span class="text fs-12">Distance</span>' +
                                        '<span class="fs-14">' + metersToDistance(route.route_distance) + '</span>' +
                                    '</div>' +
                                    '<div class="flex-col flex-center gap_1">' +
                                        '<span class="text fs-12">Time</span>' +
                                        '<span class="fs-14">' + secondsToHoursMin(route.moving_time) + '</span>' +
                                    '</div>' +
                                    '<div class="flex-col flex-center gap_1">' +
                                        '<span class="text fs-12">Elevation</span>' +
                                        '<span class="fs-14">' + Math.round(route.max_altitude - route.min_altitude) + 'm</span>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                            '<div class="m_route-short_bottom"><div class="name">'+route.name+'</div>' +
                        '</div>' +
                    '</div>'
                );

                if(route.road_types && route.road_types.length > 0){
                    let roadTypes = $('<div class="m_route-short_roadTypes"></div>');
                    let types = route.road_types.slice(0, 3);
                    types.forEach(type => {
                        let typeElement = $('<div class="roadType"><img class="svgBlackToWhite" src="'+type.icon+'" alt></div>');
                        roadTypes.append(typeElement);
                    })
                    item.find('.m_route-short_bottom').append(roadTypes);
                }

                item.on('click', function(){
                    self.openRoute(route.key);
                    self.mouseout(route.id);
                })

                item.on('mouseenter', function(){
                    let routeMarker = self.renderedObjects.routes.get(route.id).marker;
                    if(routeMarker){
                        routeMarker.setMap(null);
                        routeMarker.icon.scaledSize = new google.maps.Size(50, 50);
                        routeMarker.icon.size = new google.maps.Size(50, 50);
                        routeMarker.setMap(self.map);
                    }
                    self.mouseover(route.id);
                })
                item.on('mouseleave', function(){
                    let routeMarker = self.renderedObjects.routes.get(route.id).marker;
                    if(routeMarker){
                        routeMarker.setMap(null)
                        routeMarker.icon.scaledSize = new google.maps.Size(36, 36);
                        routeMarker.icon.size = new google.maps.Size(36, 36);
                        routeMarker.setMap(self.map);
                    }
                    self.mouseout(route.id);
                })

                self.routesListContainer.find('.carousel').append(item);
            })

            self.getMapContainer().append(self.routesListContainer);

            if(self.getMapContainer().width() < 1000){
                const owlCarousel = self.routesListContainer.find('.owl-carousel').owlCarousel({
                    loop: false,
                    autoWidth:true,
                    margin: 10,
                    nav: false,
                    dots: false,
                    startPosition: 1,
                    responsive: {
                        0:{
                            items: 3
                        }
                    }
                });
            }

        }
    }

    removeEventsList(){
        let self = this;
        if(self.eventsListContainer){
            self.eventsListContainer.remove();
            self.eventsListContainer = null;
        }
    }

    renderEventsList(events){

        let self = this;

        self.removeEventsList();

        self.eventsListContainer = $('<div class="map_eventsListContainer vertical"><div class="carousel custom-scrollbar"></div></div>');

        if(self.getMapContainer().width() < 1000){
            self.eventsListContainer.removeClass('vertical');
            self.eventsListContainer.find('.carousel').addClass('owl-carousel');
        }

        if(events.length > 0){
            events.forEach(ev => {

                if(!ev.cover || !ev.cover.sizes || !ev.location){
                    return;
                }

                let date = new Date(ev.start_time);
                let localeDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));

                const item = $(
                    '<div class="m_event-short">' +
                    '<div class="flex-row">' +
                    '   <div class="event_date"><span>'+date.getDate()+'</span><span>'+localeDate.toLocaleDateString('en-EN', {month: 'short'})+'</span></div>' +
                    '   <div class="r_event-preview">' +
                    '       <div class="prev_img">' +
                    '           <img src="' + ev.cover.sizes[ev.cover.sizes.length - 1].url + '" alt="">' +
                    '       </div>' +
                    '   </div>' +
                    '   <div class="r_event-info">' +
                    '       <div class="event_name">' + ev.name + '</div>' +
                    '       <div class="event_loc">' + ev.location.formatted + '</div>' +
                    '   </div>' +
                    '</div>' +
                    '</div>'
                );

                item.on('click', function(){
                    self.openEvent(ev.id);
                })

                item.on('mouseenter', function(){
                    let eventMarker = self.renderedObjects.events.get(ev.id);
                    if(eventMarker){
                        eventMarker.setMap(null);
                        eventMarker.icon.scaledSize = new google.maps.Size(50, 50);
                        eventMarker.icon.size = new google.maps.Size(50, 50);
                        eventMarker.setMap(self.map);
                    }
                })
                item.on('mouseleave', function(){
                    let eventMarker = self.renderedObjects.events.get(ev.id);
                    if(eventMarker){
                        eventMarker.setMap(null)
                        eventMarker.icon.scaledSize = new google.maps.Size(36, 36);
                        eventMarker.icon.size = new google.maps.Size(36, 36);
                        eventMarker.setMap(self.map);
                    }
                })

                self.eventsListContainer.find('.carousel').append(item);
            })

            self.getMapContainer().append(self.eventsListContainer);

            if(self.getMapContainer().width() < 1000){
                const owlCarousel = self.eventsListContainer.find('.owl-carousel').owlCarousel({
                    loop: false,
                    autoWidth:true,
                    margin: 10,
                    nav: false,
                    dots: false,
                    startPosition: 1,
                    responsive: {
                        0:{
                            items: 3
                        }
                    }
                });
            }

        }
    }


    getMapContainer(){
        return this.mapContainer;
    }

    createGoogleLatLng(lat, lng){
        return new google.maps.LatLng(lat, lng);
    }

    setMarkerType(marker, type, scaledSize, anchor){
        marker.data.type = type;
        scaledSize = scaledSize || [24, 24];
        anchor = anchor || [12, 12];

        let icon = {
            url: routePointTypes.get(type).icon
        }

        if(routePointTypes.get(type).anchor && routePointTypes.get(type).anchor === 'center'){
            icon.scaledSize = new google.maps.Size(scaledSize[0], scaledSize[1]);
            icon.anchor = new google.maps.Point(anchor[0], anchor[1]);
        }

        marker.setIcon(icon);
        type === 'point' ? this.setMarkerLabel(marker) : this.removeMarkerLabel(marker);
    }

    renderPoints(points, is_tracked){

        let self = this;

        if(points && points.length > 0){
            points.forEach(function(item){
                let marker = new google.maps.Marker({
                    data: item,
                    map: self.map,
                    position: item.position,
                });

                let markerType = marker.data.type;
                if(is_tracked === 1){
                    if(['start', 'finish'].indexOf(markerType) !== -1){
                        markerType = 'tracked_'+markerType;
                    }
                }

                self.setMarkerType(marker, markerType);
                self.insertMarker(marker);
            });
        }

    }

    renderPhotos(route){
        let self = this;

        route.photos.forEach((photo, index) => {

            let photoPosition = route.photos_positions.find(position => position.photo_id === photo.id);

            if(photoPosition){
                photo.sizes.forEach(size => {
                    if(size.type === 'image_100'){
                        let markerHtml = '<div class="photoContainer"><img class="photo" src="' + size.url + '" alt></div>';
                        const marker = new PhotoMarker(new google.maps.LatLng(photoPosition.lat, photoPosition.lng), markerHtml);
                        marker.setMap(self.map);
                        self.markers.push(marker);
                        marker.addListener('click', function(){
                            self.showRouteGallery(route, true, index);
                        })
                    }
                })
            }

        })

    }

    showRouteGallery(route, onMap, startIndex){

        const data = [];

        route.photos.forEach((photo, index) => {

            let photoPosition = route.photos_positions.find(position => position.photo_id === photo.id);

            if(!onMap || photoPosition){
                photo.sizes.forEach(size => {
                    if(size.type === 'image_960'){
                        data.push({
                            src: size.url,
                            type: 'image'
                        });
                    }
                })
            }

        })

        new Fancybox(data, {
            closeButton:false,
            startIndex: startIndex || startIndex,
            Toolbar: {
                display: {
                    left: [],
                    right: ["close"],
                },
            },
            Thumbs: {
                showOnStart: false,
            },
        });

    }

    renderSections(route){

        const sections = route.route_path;

        let self = this;

        let bounds = new google.maps.LatLngBounds();
        let allPolylines = [];
        let lastBeforeSectionPoint = null;

        sections.forEach((section) => {

            let polylineCoordinates;

            if(section.path[0] instanceof Object){

                polylineCoordinates = section.path.map(function(point){
                    return new google.maps.LatLng(point[0], point[1]);
                });

            }else if(section.path[0] instanceof Array){

                polylineCoordinates = section.path.map(function(point) {
                    return new google.maps.LatLng(point[0], point[1]);
                });

            }else{
                console.error('Err path instanceof');
            }

            let polyline = new google.maps.Polyline({
                path: polylineCoordinates,
                geodesic: true,
                strokeColor: self.strokeColor,
                strokeOpacity: 1.0,
                strokeWeight: self.strokeWeight * 2
            });

            let arrowline = new google.maps.Polyline({
                path: polylineCoordinates,
                strokeOpacity: 0,
                strokeWeight: self.strokeWeight * 2,
                icons: [{
                    icon: {
                        path: "M -3,0 0,-3 3,0 M -3,0 0,-3 3,0",
                        scale: 0.8,
                        strokeColor: '#FFFFFF',
                        strokeWeight: 3,
                        strokeOpacity: 0.7
                    },
                    offset: '10px',
                    repeat: '40px'
                }]
            });

            let dashedLine = null;
            let lastSectionPoint = new google.maps.LatLng(polylineCoordinates[polylineCoordinates.length - 1].lat(), polylineCoordinates[polylineCoordinates.length - 1].lng());
            let firstSectionPoint = new google.maps.LatLng(polylineCoordinates[0].lat(), polylineCoordinates[0].lng());
            if(lastBeforeSectionPoint){

                const dashedSymbol = {
                    path: "M 0,-1 0,1",
                    strokeOpacity: 0.5,
                    strokeColor: '#FFFFFF',
                    scale: 4,
                };

                const circleSymbol = {
                    path: google.maps.SymbolPath.CIRCLE,
                    fillColor: self.strokeColor,
                    fillOpacity: 1,
                    scale: 6,
                    strokeColor: "#FFFFFF",
                    strokeWeight: 2
                };

                dashedLine = new google.maps.Polyline({
                    path: [lastBeforeSectionPoint, firstSectionPoint],
                    strokeOpacity: 0,
                    icons: [
                        {
                            icon: dashedSymbol,
                            offset: '20px',
                            repeat: '20px'
                        },
                        {
                            icon: circleSymbol,
                            offset: '0%'
                        },
                        {
                            icon: circleSymbol,
                            offset: '100%'
                        }
                    ]
                });
            }

            lastBeforeSectionPoint = lastSectionPoint;

            polyline.setMap(self.map);
            arrowline.setMap(self.map);

            self.render_polylines.push(polyline);
            self.render_polylines.push(arrowline);

            if(dashedLine){
                dashedLine.setMap(self.map);
                self.render_polylines.push(dashedLine);
            }

            allPolylines.push(polylineCoordinates);
            allPolylines.forEach(pl => {
                pl.forEach(latLng => {
                    bounds.extend(latLng);
                })
            })

            self.map.fitBounds(bounds);

        });

    }

    showPoint(coordinates){

        let self = this;

        let latLng = self.createGoogleLatLng(coordinates[0], coordinates[1]);

        let marker = new google.maps.Marker({
            map: self.map,
            position: latLng
        });

        marker.setIcon({
            url: window.host + '/template/img/markers/m-def.png'
        });

        self.insertMarker(marker);
        self.map.setCenter(latLng);
        self.map.setZoom(14);

    }

    showShortPath(route_path){

        let self = this;

        let polylineCoordinates = route_path.map(function(point){
            return new google.maps.LatLng(point[0], point[1]);
        });

        let polyline = new google.maps.Polyline({
            path: polylineCoordinates,
            geodesic: true,
            strokeColor: self.strokeColor,
            strokeOpacity: self.strokeOpacity,
            strokeWeight: self.strokeWeight
        });

        polyline.setMap(self.map);

        return polyline;

    }

    showRoute(route){

        let self = this;

        let points;

        if(typeof route.route_points === 'object'){
            points = route.route_points;
        }else{
            points = JSON.parse(route.route_points);
        }

        self.hideRenderedShortRoutes();
        self.renderPoints(points, route.is_tracked);

        if(route.is_tracked === 1){

            self.renderSections(route);
            self.renderPhotos(route);

            $.get('/ajax/routes.getForMap', {key: route.key}, function(d){
                let res = ParseResp(d);
                self.route = route;
                self.renderSidebar(res.data.html);
                self.renderChart(route);
            })

        }else{

            self.calculateAndDisplayRoute(self.getWaypoints(), false).then(res => {

            }).catch(res => {

            });

        }

    }

    renderChart(route){

        let self = this;

        if(!self.sidebar) return false;

        const chartContainer = self.sidebar.getContainer().find('.m_route_charts');
        let routeChart = new RouteChart(chartContainer);
        routeChart.render(route);

        let mapCentering = null;
        chartContainer.on('onHoverPoint', function(event, position){

            let newMarkerPosition = self.createGoogleLatLng(position[0], position[1]);
            if(!self.chartMarkerPosition){
                self.chartMarkerPosition = new google.maps.Marker({
                    data: {},
                    map: self.map
                });
                self.setMarkerType(self.chartMarkerPosition, 'tracked_position', [20, 20], [10, 10]);
            }
            self.chartMarkerPosition.setPosition(newMarkerPosition);

            const bounds = self.map.getBounds();
            const coordinates = self.chartMarkerPosition.getPosition();

            if((bounds && coordinates && !bounds.contains(coordinates)) || mapCentering === true) {
                self.map.setCenter(newMarkerPosition);
                mapCentering = true;
            }

        })
        chartContainer.on('mouseout', function(){
            self.deleteChartMarkerPosition();
            mapCentering = null;
        })
    }

    renderSidebar(html, route_points){

        let self = this;

        if(!self.sidebar){
            self.sidebar = new MapEventSidebar;
        }

        self.sidebar.renderSidebar(html, route_points);

        self.mapContainer.prepend(self.sidebar.getContainer());
        self.sidebar.showSidebar();

        const carouselContainer = self.sidebar.getContainer().find('.owl-carousel');

        const owlCarousel = carouselContainer.owlCarousel({
            loop: true,
            margin: 0,
            nav: false,
            dots: true,
            startPosition: 1,
            responsive: {
                0:{
                    items: 1
                }
            }
        });

        carouselContainer.on('click', '.item', function(){
            let index = $(this).data('index');
            if(index !== undefined){
                self.showRouteGallery(self.route, false, Number.parseInt(index))
            }
        })


        let dots = carouselContainer.find('.owl-dots');

        if(dots.length > 0){
            let outer = carouselContainer.find('.owl-stage-outer').first();
            let prev = $('<div class="owlCustomButton owlCustomButton-prev"><i class="icon-chevron-left"></i></div>');
            let next = $('<div class="owlCustomButton owlCustomButton-next"><i class="icon-chevron-right"></i></div>');

            carouselContainer.append(prev);
            carouselContainer.append(next);

            carouselContainer.find('.owlCustomButton').css('height', outer.outerHeight()+'px');

            prev.on('click', function(){
                owlCarousel.trigger('prev.owl.carousel');
            });
            next.on('click', function(){
                owlCarousel.trigger('next.owl.carousel');
            });

        }

        let slideContent = self.sidebar.getContainer().find('.showMore_5')[0];
        if(slideContent){
            let moreBtn = $('<span class="showMoreBtn">Show More</span>');

            // Если текст высокий, показать кнопку
            if (slideContent.scrollHeight > slideContent.clientHeight) {
                $(slideContent).parent().after(moreBtn);
            }

            moreBtn.on("click", function(){
                $(this).remove();
                $(slideContent).css('max-height', 'none');
            });
        }

        self.getMapContainer().addClass('sidebarShown');

        self.sidebar.getContainer().on('onClosed', function(){
            self.restoreMapPosition();
            self.deleteAllRoutes();
            self.showMapObjects();
            if(self.updatePointsAtChangeMap){
                self.updatePoints();
            }
            self.getMapContainer().removeClass('sidebarShown');
        })

        return self.sidebar;
    }

    deleteChartMarkerPosition(){
        let self = this;
        if(self.chartMarkerPosition){
            self.chartMarkerPosition.setMap(null);
            self.chartMarkerPosition = null;
        }
    }

    deleteAllRoutes(){

        let self = this;

        self.render_routes.forEach(route => {
            route.setMap(null);
        })

        self.markers.forEach(marker => {
            marker.setMap(null);
        })

        self.render_polylines.forEach(polyline => {
            polyline.setMap(null);
        })

        self.deleteChartMarkerPosition();

        self.render_routes = [];
        self.markers = [];

    }

    deleteMarker(marker){

        let self = this;

        self.markers.forEach(function(item, key){
            if(item === marker){
                self.markers.splice(key, 1);
                marker.setMap(null);
            }
        })
    }

    insertMarker(marker, index){

        let self = this;

        if(index !== undefined){
            self.markers.splice(index, 0, marker);
        }else{
            self.markers.push(marker);
        }

    }

    setMarkerLabel(marker){

        let self = this;

        marker.setLabel({
            text: (marker.data.index ? marker.data.index.toString() : '-'),
            className: 'waypoints--label',
            color: 'white'
        });
    }

    removeMarkerLabel(marker){

        let self = this;
        marker.setLabel(null);

    }

    getWaypoints(){

        let self = this;

        let waypoints = [];

        if(self.markers.length <= 2){
            return [];
        }

        for(let i = 1; i < self.markers.length - 1; i++){
            const marker = self.markers[i];
            waypoints.push({
                location: marker.position,
                stopover: false
            });
        }

        return waypoints;

    }

    generateMarkers(){

        let self = this;

        let waypoints = [];

        let markerStart = self.markers[0];
        markerStart.data.index = 0;
        self.setMarkerType(markerStart, 'start');

        if(self.markers.length < 2) return waypoints;

        let markerEnd = self.markers[self.markers.length - 1];
        markerEnd.data.index = self.markers.length - 1;
        self.setMarkerType(markerEnd, 'finish');

        for(let i = 1; i < self.markers.length - 1; i++){
            const marker = self.markers[i];
            marker.data.index = i;
            if(
                marker.data.type === 'point' ||
                marker.data.type === 'finish'
            ){
                self.setMarkerType(marker, 'point');
                self.setMarkerLabel(marker);
            }
            waypoints.push({
                location: marker.position,
                stopover: false
            });
        }

        return waypoints;

    }

    /**
     * @param waypoints
     * @param {boolean} preserveViewport - false, если нужно отключить масштабирование после измнения маршрута
     */
    calculateAndDisplayRoute(waypoints, preserveViewport){

        let self = this;

        let markerStart = self.markers[0];
        let markerEnd   = self.markers[self.markers.length - 1];

        const DirectionsRoute = {
            origin: new google.maps.LatLng(markerStart.position.lat(), markerStart.position.lng()),
            destination: new google.maps.LatLng(markerEnd.position.lat(), markerEnd.position.lng()),
            waypoints: waypoints,
            optimizeWaypoints: true,
            travelMode: google.maps.TravelMode.DRIVING,
            avoidTolls: true
        }

        return self.sendToDirectionServices(DirectionsRoute, preserveViewport);

    }
    /**
     * @param {object} DirectionsRoute
     * @param {boolean} preserveViewport - false, если нужно отключить масштабирование после измнения маршрута
     */
    sendToDirectionServices(DirectionsRoute, preserveViewport){

        let self = this;

        return new Promise((resolve, reject) => {

            self.directionsService.route(DirectionsRoute, (response, status) => {

                    if(status === "OK"){

                        let DirectionRenderer = new google.maps.DirectionsRenderer({
                            map: self.map,
                            suppressMarkers: true,
                            suppressInfoWindows: false,
                            preserveViewport: preserveViewport,
                            polylineOptions: {
                                strokeColor: self.strokeColor,
                                strokeWeight: self.strokeWeight
                            }
                        });

                        DirectionRenderer.setDirections(response);
                        self.render_routes.push(DirectionRenderer);

                        resolve();

                    }else if(status === "ZERO_RESULTS"){
                        if(self.markers.length < 2) resolve();
                        reject();
                    }else if(status === "MAX_WAYPOINTS_EXCEEDED"){
                        console.error(status);
                        reject();
                    }else{
                        console.error(status);
                        reject();
                    }
                }
            )

        })

    }

    getRoutePath(){
        return this.route ? this.route.overview_path : null;
    }

    getRouteDistance(){
        return this.route ? this.route.legs[0].distance.value : null;
    }

    onUpdateRoutePath(){

        let self = this;

        if(self.onUpdateRoute){
            self.onUpdateRoute(self);
        }

    }

    aligment(){

        let self = this;
        if(self.route){
            self.map.fitBounds(self.route.bounds);
        }else if(self.point){
            self.map.setCenter(self.point.getPosition());
            self.map.setZoom(9);
        }
    }

    showRenderedShortRoutes(){
        let self = this;

        self.renderedObjects.routes.forEach(obj => {
            obj.marker.setMap(self.map);
            obj.polylines.forEach(polyline => {
                polyline.setMap(self.map);
            });
        })
    }

    hideRenderedShortRoutes(remove){
        let self = this;
        self.renderedObjects.routes.forEach(obj => {
            obj.marker.setMap(null);
            obj.polylines.forEach(polyline => {
                polyline.setMap(null);
            });
        })
        if(remove === true){
            self.renderedObjects.routes = new Map;
        }
    }

    deleteAllRenderedShortRoutes(){
        let self = this;
        self.hideRenderedShortRoutes(true);
        self.removeRoutesList();
    }

    showRenderedEvents(){
        let self = this;

        self.renderedObjects.events.forEach(marker => {
            marker.setMap(self.map);
        })
    }

    hideRenderedEvents(remove){
        let self = this;
        self.renderedObjects.events.forEach(marker => {
            marker.setMap(null);
        })

        if(remove === true){
            self.renderedObjects.events = new Map;
        }
    }

    deleteAllRenderedEvents(){
        let self = this;
        self.hideRenderedEvents(true);
        self.removeEventsList();
    }


    hideRenderedPoi(remove){
        let self = this;
        self.renderedObjects.poi.forEach(marker => {
            marker.setMap(null);
        })

        if(remove === true){
            self.renderedObjects.poi = new Map;
        }
    }

    deleteAllRenderedPoi(){
        let self = this;
        self.hideRenderedPoi(true);
    }


    hideMapObjects(){

        let self = this;

        self.hidenMapObjects = true;
        self.hideRenderedShortRoutes();

    }

    showMapObjects(){
        let self = this;
        self.hidenMapObjects = false;
        self.showRenderedShortRoutes();
    }

    deleteMapObject(type, id){
        let self = this;
        let obj;
        switch(type){
            case 'twistyPoints':

                if(id === 'all'){
                    self.renderedObjects.twistyPoints.forEach((p, key) => {
                        p.setMap(null);
                        self.renderedObjects.twistyPoints.delete(key);
                    })
                }else{
                    let point = self.renderedObjects.twistyPoints.get(id);
                    point.setMap(null);
                    self.renderedObjects.twistyPoints.delete(id);
                }

                break;
            case 'business':
                let mark = self.renderedObjects.business.get(id);
                mark.setMap(null);
                self.renderedObjects.business.delete(id);
                break;
            case 'events':
                let marker = self.renderedObjects.events.get(id);
                marker.setMap(null);
                self.renderedObjects.events.delete(id);
                break;
            case 'poi':
                let poiMarker = self.renderedObjects.poi.get(id);
                poiMarker.setMap(null);
                self.renderedObjects.poi.delete(id);
                break;
            case 'routes':
                obj = self.renderedObjects.routes.get(id);
                if(obj.marker) obj.marker.setMap(null);
                if(obj.polylines) {
                    obj.polylines.forEach(polyline => {
                        polyline.setMap(null);
                    })
                }
                self.renderedObjects.routes.delete(id);
                break;
            default:
                console.error('TypeError');
        }

    }

    saveMapPosition(){

        let self = this;
        self.savedMapPosition = {
            center: self.map.getCenter(),
            zoom: self.map.getZoom()
        }

    }

    restoreMapPosition(){
        let self = this;

        if(self.savedMapPosition){
            self.map.setCenter(self.savedMapPosition.center);
            self.map.setZoom(self.savedMapPosition.zoom);
        }
    }

    openEvent(id, firstOpen){

        let self = this;

        if(firstOpen !== true){
            self.saveMapPosition();
        }

        self.deleteAllRoutes();
        self.hideMapObjects();

        $.get('/ajax/events.getForMap', {id: id}, function(d){

            let res = ParseResp(d);

            self.renderSidebar(res.data.html, res.data.route_points);

            if(res.data.route_key){
                self.openRoute(res.data.route_key, firstOpen);
            }
            if(res.data.point){
                //self.showPoint(res.data.point.split(","))
            }

        })

    }

    openPoi(id, firstOpen){

        let self = this;

        if(firstOpen !== true) self.saveMapPosition();

        self.deleteAllRoutes();
        self.hideMapObjects();

        $.get('/ajax/poi.getForMap', {id: id}, function(d){
            let res = ParseResp(d);
            self.renderSidebar(res.data.html);
        })

    }

    openRoute(key, firstOpen){

        let self = this;

        if(firstOpen !== true){
            self.saveMapPosition();
        }

        self.deleteAllRoutes();
        self.hideMapObjects();

        $.get("/ajax/getRouteByKey", {key: key}, function(d){
            let res = ParseResp(d);
            if(res){
                let route = res.data.route;
                self.showRoute(route);
            }
        })

    }

    openUserMap(userId){

        let self = this;

        $.get("/ajax/users.getUserMap", {user_id: userId}, function(d){
            let res = ParseResp(d);
            if(res){
                let routes = res.data.tracked_routes ?? null;
                if(routes){
                    self.showRoutes(routes);

                    if(res.data.bounds){
                        let bounds = new google.maps.LatLngBounds();
                        bounds.extend(res.data.bounds.southwest);
                        bounds.extend(res.data.bounds.northeast);

                        self.map.fitBounds(bounds);
                    }

                }

            }
        })

    }

}

export default MapViewer;